(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["brand-story-intro"] && !Shopify.designMode) return;
  try {
    
  class BrandStoryReveal extends HTMLElement {
    connectedCallback() {
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        this.setAttribute('revealed', '');
        return;
      }

      this.observer = new IntersectionObserver(
        (entries) => {
          if (!entries.some((entry) => entry.isIntersecting)) return;
          this.setAttribute('revealed', '');
          this.observer.disconnect();
        },
        { rootMargin: '0px 0px -20% 0px' }
      );
      this.observer.observe(this);
    }

    disconnectedCallback() {
      this.observer?.disconnect();
    }
  }

  if (!customElements.get('brand-story-reveal')) {
    customElements.define('brand-story-reveal', BrandStoryReveal);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
